<template>
  <div>
    <PromoBanners />
    <FlashDeals />
    <BestSellers v-if="!noBestSellersProduct" />
    <HotDeals />
    <!-- <BecomeAgentHero v-if="currentUser ? currentUser.roles !== 'Agent' : true" /> -->
    <Article />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FlashDeals from '@/components/storefront/FlashDeals.vue'
import PromoBanners from '@/components/storefront/PromoBanners.vue'
import BestSellers from '@/components/storefront/BestSellers.vue'
import HotDeals from '@/components/storefront/HotDeals.vue'
// import BecomeAgentHero from '@/components/storefront/BecomeAgentHero.vue'
import Article from '@/components/storefront/Article.vue'

export default {
  components: {
    FlashDeals,
    PromoBanners,
    BestSellers,
    HotDeals,
    // BecomeAgentHero,
    Article
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapGetters('page', ['bestSellers']),
    noBestSellersProduct() {
      return this.bestSellers && this.bestSellers.length === 1 && this.bestSellers[0].slider_image_id === null
    }
  }
}
</script>
